import { gql } from "apollo-angular";

const CREATE_DATA_SCOPE = gql`
  mutation createDataScope($createDataScopeInput: CreateDataScopeInput!) {
    createDataScope(createDataScopeInput: $createDataScopeInput) {
      id
      name
      type
      status
      description
      launchURL
      tags
      parameters
      createdAt
      updatedAt
    }
  }
`;

const UPDATE_DATA_SCOPE = gql`
  mutation updateDataScope($updateDataScopeInput: UpdateDataScopeInput!) {
    updateDataScope(updateDataScopeInput: $updateDataScopeInput) {
      id
      name
      description
      tags
      status
    }
  }
`;

const GET_ASSETS_BY_RELATIONSHIPS_BY_ID = gql`
  query getAssetsByRelationshipsById($assetId: String!, $relatedAssetTypes: [String!]!) {
    getAssetsByRelationships(getAssetsByRelationshipsInput: {
      assetId: $assetId,
      relatedAssetTypes: $relatedAssetTypes
    })
  }
`;

const GET_ASSETS_BY_RELATIONSHIPS_BY_TYPE = gql`
  query getAssetsByRelationshipsByType($assetTypes: [String!]!, $relatedAssetTypes: [String!]!) {
    getAssetsByRelationships(getAssetsByRelationshipsInput: {
      assetTypes: $assetTypes,
      relatedAssetTypes: $relatedAssetTypes
    })
  }
`;
const FIND_ASSET_BY_RELATIONSHIP = gql`
  query findAssetsByRelationship($primaryAssetId: [String!], $secondaryAssetType: [AssetType!], $matchAnyPrimary: Boolean) {
    findAssetsByRelationship(findAssetsByRelationshipInput: {
      primaryAssetId: $primaryAssetId,
      secondaryAssetType: $secondaryAssetType,
      matchAnyPrimary: $matchAnyPrimary
    }){
      id 
      name 
      type 
      status
      parameters
      createdAt
      updatedAt
      creator
      tags
      description
    }
  }
`;


export { CREATE_DATA_SCOPE, GET_ASSETS_BY_RELATIONSHIPS_BY_ID, GET_ASSETS_BY_RELATIONSHIPS_BY_TYPE, UPDATE_DATA_SCOPE, FIND_ASSET_BY_RELATIONSHIP };